import styles from './Content.module.scss';
import cn from 'classnames';

const Content = ({ children }) => {
  return <div className={cn(styles.content, 'S')}>{children}</div>;
};

export default Content;
